<template>
    <div id="data-list-thumb-view" class="data-list-container">

        <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData"/>

        <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="companies">

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <div class="flex flex-wrap-reverse items-center">

                    <!-- ADD NEW -->
                    <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
                         @click="addNewData">
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
                        <span class="ml-2 text-base text-primary">Nieuw bedrijf</span>
                    </div>
                </div>


                <!-- ITEMS PER PAGE -->
                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ companies.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : companies.length }} of {{ queriedItems }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                    </div>
                    <vs-dropdown-menu>

                        <vs-dropdown-item @click="itemsPerPage=15">
                            <span>4</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=25">
                            <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=50">
                            <span>15</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=100">
                            <span>20</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <template slot="thead">
                <vs-th></vs-th>
                <vs-th sort-key="name">Name</vs-th>
                <vs-th sort-key="adres">Address</vs-th>
                <vs-th sort-key="status">Status</vs-th>
                <vs-th sort-key="phone-number">Phone Number</vs-th>
                <vs-th>Action</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click.native="editData(tr)">

                    <vs-td class="img-container">
                        <img :src="tr.logo" class="company-img"/>
                    </vs-td>

                    <vs-td>
                        <p class="company-name font-medium truncate">{{ tr.name }}</p>
                    </vs-td>

                    <vs-td>
                        <p class="company-adres">{{ tr.adres }}</p>
                    </vs-td>

                    <vs-td>
                        <p class="company-status">{{ getStatus(tr.status) }}</p>
                    </vs-td>

                    <vs-td>
                        <p class="company-price">{{ tr.phone_number }}</p>
                    </vs-td>

                    <vs-td class="whitespace-no-wrap">
                        <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                     />
                        <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                      class="ml-2" @click.stop="deleteData(tr.id)"/>
                    </vs-td>

                </vs-tr>
                </tbody>

                <ht-company-popup></ht-company-popup>
            </template>
        </vs-table>
    </div>
</template>

<script>
    import DataViewSidebar from './DataViewSidebar.vue';
    import CompanyPopup from './CompanyPopup.vue';

    export default {
        components: {
            DataViewSidebar,
            'ht-company-popup': CompanyPopup
        },
        data() {
            return {
                selected: [],
                companies: [],
                itemsPerPage: 15,
                isMounted: false,
                addNewDataSidebar: false,
                sidebarData: {}
            };
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx;
                }
                return 0;
            },
            queriedItems() {
                return this.$refs.table ? this.$refs.table.queriedResults.length : this.companies.length;
            }
        },
        methods: {
            getCompanies() {
                this.$http.get('https://staffapi.hebtrek.nl/v1/companies/list', {
                    headers: {
                        Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('stafftoken'))
                    }
                }).then((response) => {
                    this.companies = response.data.data;
                }).catch((error) => {
                    this.$util.logError(error, this.$vs);
                });
            },
            addNewData() {
                this.$router.push('/companies/create');
            },
            deleteData(id) {
                // Delete company
            },
            editData(data) {
                this.$router.push('/companies/' + data.slug + '/dashboard');
            },
            getOrderStatusColor(status) {
                if (status === 'on_hold') return 'warning';
                if (status === 'delivered') return 'success';
                if (status === 'canceled') return 'danger';
                return 'primary';
            },
            getPopularityColor(num) {
                if (num > 90) return 'success';
                if (num > 70) return 'primary';
                if (num >= 50) return 'warning';
                if (num < 50) return 'danger';
                return 'primary';
            },
            toggleDataSidebar(val = false) {
                this.addNewDataSidebar = val;
            },
            getStatus(status) {
                if (status == 0) {
                    return 'inactief';
                }
                if (status == 1) {
                    return 'open';
                }
                if (status == 2) {
                    return 'gesloten';
                }
                if (status == 3) {
                    return 'gesloten';
                }
                if (status == 4) {
                    return 'Binnenkort geopend';
                }
            }
        },
        created() {

        },
        mounted() {
            this.isMounted = true;
            this.getCompanies();
        }
    };
</script>

<style lang="scss">
    #data-list-thumb-view {
        .vs-con-table {

            .company-name {
                max-width: 23rem;
            }

            .vs-table--header {
                display: flex;
                flex-wrap: wrap-reverse;
                margin-left: 1.5rem;
                margin-right: 1.5rem;

                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search {
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 2.5rem;
                        font-size: 1rem;

                        & + i {
                            left: 1rem;
                        }

                        &:focus + i {
                            left: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 1.3rem;
                padding: 0 1rem;


                tr {
                    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

                    td {
                        padding: 10px;

                        &:first-child {
                            border-top-left-radius: .5rem;
                            border-bottom-left-radius: .5rem;
                        }

                        &:last-child {
                            border-top-right-radius: .5rem;
                            border-bottom-right-radius: .5rem;
                        }

                        &.img-container {
                            width: 1rem;
                            background: #fff;

                            span {
                                display: flex;
                                justify-content: flex-start;
                            }

                            .company-img {
                                max-height: 100px;
                                max-width: 100px;
                            }
                        }
                    }

                    td.td-check {
                        padding: 20px !important;
                    }
                }
            }

            .vs-table--thead {
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text {
                        text-transform: uppercase;
                        font-weight: 600;
                    }
                }

                th.td-check {
                    padding: 0 15px !important;
                }

                tr {
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>
